import { type ReactNode } from 'react';
import { useAuth } from '../context/AuthContext';

export default function AppLayout({ children }: { children: ReactNode }) {
  const { logout } = useAuth();
  return (
    <div className="min-h-screen bg-[linear-gradient(135deg,#f8fafc_0%,#f1f5f9_50%,#fefce8_100%)]">
      <header className="bg-white border-b border-slate-200">
        <div className="max-w-4xl mx-auto px-4 py-4 flex items-center justify-between">
          <div className="flex items-center gap-4">
            <a href="https://getboby.ai" target="_blank" rel="noopener noreferrer" className="block leading-none">
              <img src="/BobyWordmark-PinLogoInGold.png" alt="Boby" className="h-8 block"
                onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }} />
            </a>
          </div>
          <button type="button" onClick={logout} className="text-sm font-medium text-gray-600 hover:text-gray-900">Sign out</button>
        </div>
      </header>
      <main className="max-w-4xl mx-auto px-4 py-8 space-y-6">
        {children}
      </main>
    </div>
  );
}
